import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './app/App'
import './index.css'

// Clean up any old root-level service workers
// Only per-game service workers should be registered
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      // Unregister any service worker at root scope
      if (registration.scope === window.location.origin + '/') {
        registration.unregister()
        console.log('[Cleanup] Unregistered root service worker')
      }
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)
